import family from "../../images/family.png";
import top from "../../images/top-proposito.png";

import "./Proposito.css";

export const Proposito = () => {
  return (
    <div id="proposito">
      <div className="proposito-container-top">
        <img className="proposito-image-top" src={top} alt="Top Porpósito" />
      </div>

      <div className="proposito-container">
        <div className="proposito-box">
          <h1 style={{ fontWeight: "600" }}>Propósito</h1>
          <br />
          <p>
            La etapa +65 años es rica en experiencia, en sabiduría, en capacidad
            de dar y recibir cariño, en entender las cosas realmente importantes
            de la vida. Y es una etapa que, como cualquier otra, tiene sus
            desafíos.
          </p>
          <p>
            Somos Ellie Care, y tenemos una vocación que nos une y moviliza:
            ayudar a los +65 y sus familias a vivir plenamente esta lindísima
            etapa de la vida, con salud, seguridad, independencia, y cerca de
            los afectos.
          </p>
          <p>¡Juntos podemos construir un mundo mas SENIOR FRIENDLY!</p>
        </div>
        <div className="proposito-box-image" style={{ display: "flex" }}>
          <img
            className="proposito-image"
            src={family}
            alt="Illustration of a family"
          />
        </div>
      </div>
    </div>
  );
};

export default Proposito;
